export default {
    //URL: 'https://localhost:32770',
    URL: 'https://odrapi.yosocom.co.kr',
    ROUTES: {
        register: '/',
    },
    HEADERS: {
        'ApiKey' : '84be4c9byjni8450t4hm5878f6932713'
    },
}